import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="rounded-[10px] border border-white-300 bg-white-50 p-7">
      <h1 className="m-0 mb-1.5 text-headline-sm font-bold tracking-[-0.02em]">찾는 화면이 없습니다</h1>
      <p className="m-0 mb-7 text-body-sm text-black-100">주소가 바뀌었거나 삭제된 화면일 수 있습니다.</p>
      <Link className="cursor-pointer rounded-lg border border-black-600 bg-black-600 px-[22px] py-[11px] font-semibold text-white-50 disabled:cursor-not-allowed disabled:opacity-50" to="/">
        홈으로
      </Link>
    </div>
  )
}
